import {
    CUSTOMERBASE_KO,
    INVOICING_OK,
    INVOICING_REQUESTED,
    INVOICING_REQUESTED_DO_NOT_SEND,
    TOBE_SENT
} from "./Constants";
import {useTranslation} from "react-i18next";
import {useTheme} from "@mui/material";


export const useAmazonInvoiceStatusValuesVoucher = () => {
    const {t} = useTranslation(['salesmarketing']);
    const theme = useTheme();
    const getAmazonInvoiceStatusColorVoucher = (status: string) => {
        switch (status) {
            case TOBE_SENT: return theme.palette.info.light;
            case CUSTOMERBASE_KO: return theme.palette.warning.transparent;
            case INVOICING_REQUESTED: return theme.palette.secondary.transparent;
            case INVOICING_OK: return theme.palette.success.transparent;
            case INVOICING_REQUESTED_DO_NOT_SEND: return theme.palette.error.transparent;
        }
    };

    const getAmazonInvoiceStatusLabelVoucher = (status: string) => {
        switch (status) {
            case TOBE_SENT: return t('voucher.amazonInvoiceStatus.TOBE_SENT');
            case CUSTOMERBASE_KO: return t('voucher.amazonInvoiceStatus.CUSTOMERBASE_KO');
            case INVOICING_REQUESTED: return t('voucher.amazonInvoiceStatus.INVOICING_REQUESTED');
            case INVOICING_OK: return t('voucher.amazonInvoiceStatus.INVOICING_OK');
            case INVOICING_REQUESTED_DO_NOT_SEND: return t('voucher.amazonInvoiceStatus.INVOICING_REQUESTED_DO_NOT_SEND');
            default : return '-'
        }
    };

    return {
        getAmazonInvoiceStatusColorVoucher,
        getAmazonInvoiceStatusLabelVoucher
    }
}